<template>
  <div></div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  methods: {
    async checkToken() {
      try {
        const token = await this.$auth0.getAccessTokenSilently();
        this.setAccessToken(token);

        if (this.$auth0.isAuthenticated.value) {
          this.$router.push({ name: "callback" });
        }
      } catch {
        this.$auth0.loginWithRedirect();
      }
    },
    ...mapActions("authData", ["setAccessToken"]),
  },
  // Checks if user is logged in
  created() {
    this.checkToken();
  },
};
</script>
